import PropTypes from 'prop-types';
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceZohoRecruit = (props) => {

    const ClientId = "1000.T249DIATGXB6MXPYAVO2S2LB3E96KH"
    const Scope = "ZohoRecruit.modules.READ,ZohoRecruit.modules.call.CREATE,ZohoRecruit.modules.call.UPDATE,ZohoRecruit.users.READ,ZohoRecruit.settings.READ,ZohoRecruit.org.READ"
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"
    const AuthUrl = "https://accounts.zoho.com/oauth/v2/auth?scope=" + Scope + "&client_id=" + ClientId + "&response_type=code&access_type=offline&redirect_uri=" + RedirectUrl

    const OAuthPollResult = async (aResponseUrl) =>
    {
        console.log("OAuthPollResult", aResponseUrl)
        if (aResponseUrl)
        {
            if (aResponseUrl.includes("zoho.com.au")) { props.IntegrationSettings.DatasourceSettings.Domain = ".com.au" }
            else if (aResponseUrl.includes("zoho.eu")) { props.IntegrationSettings.DatasourceSettings.Domain = ".eu" }
            else if (aResponseUrl.includes("zoho.in")) { props.IntegrationSettings.DatasourceSettings.Domain = ".in" }
            else if (aResponseUrl.includes("zoho.com.cn")) { props.IntegrationSettings.DatasourceSettings.Domain = ".com.cn" }
            else if (aResponseUrl.includes("zoho.jp")) { props.IntegrationSettings.DatasourceSettings.Domain = ".jp" }
            else { props.IntegrationSettings.DatasourceSettings.Domain = ".com" }

            props.OnSetReady()
        }
    }

    return <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController="/api/zohorecruit/tokens" OnOAuthPollResult={OAuthPollResult} OnSetReady={props.OnSetReady}/>
}

DatasourceZohoRecruit.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceZohoRecruit